/**
 * bp-dialog.js — Beptum vlastní dialog systém
 * Nahrazuje nativní alert() / confirm() hezčími modály + bonus toast.
 *
 * API:
 *   bpAlert(message, { title, okText, type })            → Promise<void>
 *   bpConfirm(message, { title, okText, cancelText, danger, type }) → Promise<boolean>
 *   bpEmailPrompt({ title, message, label, consentText, privacyUrl, … }) → Promise<{email, consent}|null>
 *   bpToast(message, { type, duration })                 → void
 *
 *   type: 'info' | 'success' | 'warning' | 'error'
 *
 * Bez závislostí, vanilla JS. CSS se injektuje jednou.
 */
(function () {
  if (window.bpAlert) return; // už načteno

  // ── Ikony (Heroicons, MIT) — jeden zdroj pravdy pro JS ────────
  // Path data z https://heroicons.com (outline 24px). currentColor dědí barvu.
  const BP_ICONS = {
    'home': '<path d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"/>',
    'rectangle-stack': '<path d="M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.246 2.246 0 0 0-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122"/>',
    'swatch': '<path d="M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z"/>',
    'squares-2x2': '<path d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"/>',
    'magnifying-glass': '<path d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/>',
    'cog-6-tooth': '<path d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 0 1 0 .255c-.007.378.138.75.43.991l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 0 1 0-.255c.007-.378-.138-.75-.43-.991l-1.004-.828a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281Z"/><path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>',
    'document-text': '<path d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>',
    'check-circle': '<path d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>',
    'shopping-cart': '<path d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>',
    'folder-open': '<path d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776"/>',
    'clipboard-document-list': '<path d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"/>',
    'trash': '<path d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"/>',
    'pencil-square': '<path d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"/>',
    'exclamation-triangle': '<path d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>',
    'x-circle': '<path d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>',
    'information-circle': '<path d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"/>',
    'question-mark-circle': '<path d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"/>',
  };

  // bpIcon('trash') → SVG string. opts.cls přidá třídu, opts.style inline styl.
  window.bpIcon = function (name, opts = {}) {
    const path = BP_ICONS[name];
    if (!path) return '';
    const cls = 'bp-ic' + (opts.cls ? ' ' + opts.cls : '');
    const style = opts.style ? ` style="${opts.style}"` : '';
    return `<svg class="${cls}"${style} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${path}</svg>`;
  };

  const TYPE_ICON  = { info: 'information-circle', success: 'check-circle', warning: 'exclamation-triangle', error: 'x-circle', confirm: 'question-mark-circle' };
  const TYPE_COLOR = { info: '#2563eb', success: '#2e7d32', warning: '#e08600', error: '#c0392b', confirm: '#555' };

  // ── Injekce CSS (jednou) ──────────────────────────────────────
  const CSS = `
  .bp-ic {
    width: 1.15em; height: 1.15em; display: inline-block;
    vertical-align: -0.18em; flex-shrink: 0;
  }
  .bp-dlg-overlay {
    position: fixed; inset: 0; z-index: 100000;
    background: rgba(0,0,0,0.5);
    display: flex; align-items: center; justify-content: center;
    padding: 16px; opacity: 0; transition: opacity .18s ease;
    font-family: inherit;
  }
  .bp-dlg-overlay.bp-show { opacity: 1; }
  .bp-dlg-box {
    background: #fff; border-radius: 12px;
    max-width: 420px; width: 100%;
    box-shadow: 0 12px 48px rgba(0,0,0,0.28);
    padding: 28px 26px 22px;
    transform: translateY(8px) scale(.98);
    transition: transform .18s ease;
    text-align: center;
  }
  .bp-dlg-overlay.bp-show .bp-dlg-box { transform: translateY(0) scale(1); }
  .bp-dlg-icon { font-size: 2.6em; line-height: 1; margin-bottom: 10px; }
  .bp-dlg-icon .bp-ic { width: 1em; height: 1em; vertical-align: middle; }
  .bp-dlg-title { font-size: 1.15em; font-weight: 700; margin: 0 0 8px; color: #1a1a1a; }
  .bp-dlg-msg { font-size: .92em; color: #555; line-height: 1.5; margin: 0 0 22px; white-space: pre-line; }
  .bp-dlg-actions { display: flex; gap: 10px; justify-content: center; }
  .bp-dlg-btn {
    padding: 10px 22px; border-radius: 7px; font-size: .92em; font-weight: 600;
    border: none; cursor: pointer; transition: background .15s, opacity .15s; min-width: 96px;
  }
  .bp-dlg-btn-primary { background: #222; color: #fff; }
  .bp-dlg-btn-primary:hover { background: #444; }
  .bp-dlg-btn-danger { background: #c0392b; color: #fff; }
  .bp-dlg-btn-danger:hover { background: #a5281b; }
  .bp-dlg-btn-secondary { background: #ececec; color: #333; }
  .bp-dlg-btn-secondary:hover { background: #ddd; }
  .bp-dlg-form { text-align: left; margin: -8px 0 20px; font-size: .9em; }
  .bp-dlg-label { display: block; font-weight: 600; color: #333; }
  .bp-dlg-input {
    display: block; width: 100%; box-sizing: border-box; margin-top: 6px;
    padding: 10px 12px; border: 1px solid #ccc; border-radius: 7px; font: inherit; font-weight: 400;
  }
  .bp-dlg-input:focus { outline: 2px solid #222; outline-offset: 1px; }
  .bp-dlg-error { color: #c0392b; margin: 6px 0 0; }
  .bp-dlg-check { display: flex; gap: 8px; align-items: flex-start; margin-top: 14px; color: #555; line-height: 1.4; cursor: pointer; }
  .bp-dlg-check input { margin-top: 3px; flex-shrink: 0; }
  .bp-dlg-note { margin: 10px 0 0; font-size: .9em; }
  .bp-dlg-note a { color: #555; }

  .bp-toast-wrap {
    position: fixed; top: 20px; right: 20px; z-index: 100001;
    display: flex; flex-direction: column; gap: 10px;
    pointer-events: none;
  }
  .bp-toast {
    background: #222; color: #fff; padding: 13px 18px; border-radius: 8px;
    font-size: .9em; font-weight: 500; box-shadow: 0 6px 24px rgba(0,0,0,0.22);
    display: flex; align-items: center; gap: 10px; max-width: 360px;
    opacity: 0; transform: translateX(20px); transition: opacity .25s, transform .25s;
    pointer-events: auto;
  }
  .bp-toast.bp-show { opacity: 1; transform: translateX(0); }
  .bp-toast-success { background: #2e7d32; }
  .bp-toast-error   { background: #c0392b; }
  .bp-toast-warning { background: #e08600; }
  .bp-toast-icon { font-size: 1.15em; line-height: 1; }
  @media (max-width: 480px) {
    .bp-toast-wrap { left: 12px; right: 12px; top: 12px; }
    .bp-toast { max-width: none; }
  }

  .bp-loading-overlay {
    position: fixed; inset: 0; z-index: 100002;
    background: rgba(255,255,255,0.72);
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 18px; opacity: 0; transition: opacity .18s ease;
    backdrop-filter: blur(1.5px);
  }
  .bp-loading-overlay.bp-show { opacity: 1; }
  .bp-spinner {
    width: 48px; height: 48px; border-radius: 50%;
    border: 4px solid #e0e0e0; border-top-color: #222;
    animation: bp-spin .8s linear infinite;
  }
  @keyframes bp-spin { to { transform: rotate(360deg); } }
  .bp-loading-msg { font-size: .95em; font-weight: 600; color: #333; }
  `;

  function injectCss() {
    if (document.getElementById('bp-dlg-styles')) return;
    const style = document.createElement('style');
    style.id = 'bp-dlg-styles';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  // ── Společný modal builder ────────────────────────────────────
  function buildModal({ message, title, okText, cancelText, type, danger, isConfirm }) {
    injectCss();

    const overlay = document.createElement('div');
    overlay.className = 'bp-dlg-overlay';

    let iconKey;
    if (isConfirm) iconKey = danger ? 'warning' : 'confirm';
    else iconKey = type || 'info';
    const iconName = TYPE_ICON[iconKey] || TYPE_ICON.info;
    const iconColor = TYPE_COLOR[iconKey] || TYPE_COLOR.info;
    const icon = window.bpIcon(iconName);
    const primaryClass = danger ? 'bp-dlg-btn-danger' : 'bp-dlg-btn-primary';

    overlay.innerHTML = `
      <div class="bp-dlg-box" role="dialog" aria-modal="true">
        <div class="bp-dlg-icon" style="color:${iconColor}">${icon}</div>
        ${title ? `<p class="bp-dlg-title">${title}</p>` : ''}
        <p class="bp-dlg-msg">${String(message).replace(/</g, '&lt;')}</p>
        <div class="bp-dlg-actions">
          ${isConfirm ? `<button class="bp-dlg-btn bp-dlg-btn-secondary" data-bp="cancel">${cancelText}</button>` : ''}
          <button class="bp-dlg-btn ${primaryClass}" data-bp="ok">${okText}</button>
        </div>
      </div>`;

    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('bp-show'));

    return overlay;
  }

  function closeModal(overlay) {
    overlay.classList.remove('bp-show');
    setTimeout(() => overlay.remove(), 180);
  }

  // ── bpAlert ───────────────────────────────────────────────────
  window.bpAlert = function (message, opts = {}) {
    return new Promise((resolve) => {
      const overlay = buildModal({
        message,
        title: opts.title || '',
        okText: opts.okText || 'OK',
        type: opts.type || 'info',
        isConfirm: false,
      });
      const finish = () => { closeModal(overlay); resolve(); };
      overlay.querySelector('[data-bp="ok"]').addEventListener('click', finish);
      overlay.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === 'Escape') finish(); });
      overlay.querySelector('[data-bp="ok"]').focus();
    });
  };

  // ── bpConfirm ─────────────────────────────────────────────────
  window.bpConfirm = function (message, opts = {}) {
    return new Promise((resolve) => {
      const overlay = buildModal({
        message,
        title: opts.title || 'Bestätigung',
        okText: opts.okText || 'OK',
        cancelText: opts.cancelText || 'Abbrechen',
        type: opts.type || 'warning',
        danger: !!opts.danger,
        isConfirm: true,
      });
      const done = (val) => { closeModal(overlay); resolve(val); };
      overlay.querySelector('[data-bp="ok"]').addEventListener('click', () => done(true));
      overlay.querySelector('[data-bp="cancel"]').addEventListener('click', () => done(false));
      overlay.addEventListener('click', (e) => { if (e.target === overlay) done(false); });
      document.addEventListener('keydown', function escH(e) {
        if (!document.body.contains(overlay)) { document.removeEventListener('keydown', escH); return; }
        if (e.key === 'Escape') { done(false); document.removeEventListener('keydown', escH); }
      });
      overlay.querySelector('[data-bp="ok"]').focus();
    });
  };

  // ── bpEmailPrompt ─────────────────────────────────────────────
  // E-mail (povinný) + nepovinný souhlas → Promise<{ email, consent } | null> (null = zrušeno).
  // opts: title, message, label, consentText, privacyText, privacyUrl, okText, cancelText, invalidText, value
  window.bpEmailPrompt = function (opts = {}) {
    return new Promise((resolve) => {
      const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const overlay = buildModal({
        message: opts.message || '',
        title: opts.title || '',
        okText: opts.okText || 'OK',
        cancelText: opts.cancelText || 'Abbrechen',
        type: 'info',
        isConfirm: true,
      });
      const form = document.createElement('form');
      form.className = 'bp-dlg-form';
      form.noValidate = true;
      form.innerHTML = `
        <label class="bp-dlg-label">${esc(opts.label)}
          <input type="email" class="bp-dlg-input" autocomplete="email" required value="${esc(opts.value)}">
        </label>
        <p class="bp-dlg-error" hidden>${esc(opts.invalidText)}</p>
        ${opts.consentText ? `<label class="bp-dlg-check"><input type="checkbox"> <span>${esc(opts.consentText)}</span></label>` : ''}
        ${opts.privacyUrl ? `<p class="bp-dlg-note"><a href="${esc(opts.privacyUrl)}" target="_blank" rel="noopener">${esc(opts.privacyText || 'Datenschutz')}</a></p>` : ''}`;
      const box = overlay.querySelector('.bp-dlg-box');
      box.insertBefore(form, overlay.querySelector('.bp-dlg-actions'));
      const input = form.querySelector('input[type=email]');
      const error = form.querySelector('.bp-dlg-error');

      const done = (val) => { closeModal(overlay); resolve(val); };
      const submit = () => {
        const email = input.value.trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          error.hidden = false;
          input.focus();
          return;
        }
        const check = form.querySelector('input[type=checkbox]');
        done({ email, consent: !!(check && check.checked) });
      };
      form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
      overlay.querySelector('[data-bp="ok"]').addEventListener('click', submit);
      overlay.querySelector('[data-bp="cancel"]').addEventListener('click', () => done(null));
      overlay.addEventListener('keydown', (e) => { if (e.key === 'Escape') done(null); });
      input.addEventListener('input', () => { error.hidden = true; });
      input.focus();
    });
  };

  // ── bpToast ───────────────────────────────────────────────────
  window.bpToast = function (message, opts = {}) {
    injectCss();
    let wrap = document.querySelector('.bp-toast-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'bp-toast-wrap';
      document.body.appendChild(wrap);
    }
    const type = opts.type || 'success';
    const duration = opts.duration || 3000;
    const toast = document.createElement('div');
    toast.className = 'bp-toast bp-toast-' + type;
    const icon = window.bpIcon(TYPE_ICON[type] || TYPE_ICON.success);
    toast.innerHTML = `<span class="bp-toast-icon">${icon}</span><span>${String(message).replace(/</g, '&lt;')}</span>`;
    wrap.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('bp-show'));
    setTimeout(() => {
      toast.classList.remove('bp-show');
      setTimeout(() => toast.remove(), 260);
    }, duration);
  };

  // ── bpLoading ─────────────────────────────────────────────────
  // Použití: bpLoading.show('Plan wird geladen…'); … bpLoading.hide();
  let _loadingEl = null;
  let _loadingCount = 0; // počítadlo pro vnořené show/hide
  window.bpLoading = {
    show(message) {
      injectCss();
      _loadingCount++;
      if (_loadingEl) {
        const msgEl = _loadingEl.querySelector('.bp-loading-msg');
        if (msgEl) msgEl.textContent = message || 'Bitte warten…';
        return;
      }
      _loadingEl = document.createElement('div');
      _loadingEl.className = 'bp-loading-overlay';
      _loadingEl.innerHTML = `
        <div class="bp-spinner"></div>
        <div class="bp-loading-msg">${String(message || 'Bitte warten…').replace(/</g, '&lt;')}</div>`;
      document.body.appendChild(_loadingEl);
      requestAnimationFrame(() => _loadingEl.classList.add('bp-show'));
    },
    hide(force) {
      if (force) _loadingCount = 0; else _loadingCount = Math.max(0, _loadingCount - 1);
      if (_loadingCount > 0) return; // ještě běží jiná operace
      if (!_loadingEl) return;
      const el = _loadingEl;
      _loadingEl = null;
      el.classList.remove('bp-show');
      setTimeout(() => el.remove(), 180);
    }
  };
})();
